module.exports = __webpack_public_path__ + "img/tel.c704d3a3.png";